import Header from "../components/Header"
import Footer from "../components/Footer"
import { Link } from "react-router-dom"
import { ArrowRight } from "lucide-react"
import { ArrowButton } from "../components/common/ArrowButton"
import { useState } from "react"
import mainlandPng from '../assets/images/main-land.png'
import hongkongPng from '../assets/images/hongkong-sar.png'
import unitedPng from '../assets/images/united-states.png'
import { TrialFormPage } from '@/components/common/Trial/TrialFormPage';
import { TrialFormDialog } from '@/components/common/Trial/TrialFormDialog'
import { useNavigate } from "react-router-dom"

const mainLandProducts = [
  {
    productName: "Price-Volume Factors",
    key: '1'
  },
  {
    productName: "Model-Mined Factors",
    key: '2'
  },
  {
    productName: "Alternative Factors",
    key: '3'
  },
  {
    productName: "Alternative Data",
    key: '4'
  },
  // {
  //   productName: "Coming soon",
  //   key: '5'
  // }
];

const hongkongProducts = [
  {
    productName: "Price-Volume Factors",
    key: '1'
  },
  {
    productName: "Coming soon",
    key: '2'
  },
  {
    productName: "",
    key: '3'
  },
   {
    productName: "",
    key: '4'
  }
];

const unitedStatesProducts = [
  {
    productName: "Price-Volume Factors",
    key: '1'
  },
  {
    productName: "Coming soon",
    key: '2'
  },
  {
    productName: "",
    key: '3'
  },
   {
    productName: "",
    key: '4'
  }
]
export default function HomePage() {
  const [ trialStatus, setTrialStatus ] = useState(false);
  const navigate = useNavigate();

  const handleJump = (product, index, path) => {
    if (!product.productName) {
      return;
    }
    const params = new URLSearchParams({
      id: index + 1,
      product: product.productName
    });
    navigate(`${path}/?${params.toString()}`);
  }
  return (
    <div className="min-h-screen bg-black text-white">
      <Header />

      {/* Hero Section */}
      <section className="relative min-h-[650px] flex items-center justify-center 
      bg-[url('../assets/images/home-banner.jpg')] bg-center bg-cover bg-no-repeat
      after:absolute after:bottom-0 after:w-full after:h-[60px] after:bg-fade-out font-titillium">
        <div className="container container-max-w">
          <h1 className="text-5xl md:text-6xl font-bold mb-[12px] text-white">
            <div className="mb-[12px]">Elevate Your Fintech Journey</div>
            <div>with iData</div>
          </h1>
          <p className="mb-8 text-[28px]">From data to insights, unlock the depth and breadth of data</p>
          <ArrowButton text={ "Free Trial" } className="w-[192px] h-[62px] text-[24px]" onClick={() => setTrialStatus(true)}></ArrowButton>
        </div>
      </section>

      {/* Our Product Section */}
      <section className="py-20 bg-black">
        <div className="container container-max-w mx-auto px-4">
          <h2 className="text-[40px] mb-16">Our Product</h2>

          <div className="flex gap-[32px] mb-16">
            {/* Mainland China */}
            <div className="group">
              <Link to="/mainland-china" className="h-full">
                <div className="relative overflow-hidden mb-4 -">
                  <img
                    src={mainlandPng}
                    alt="Mainland China"
                    className="w-[421px] h-[400px] object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 group-hover:bg-black/30 transition-colors duration-300"></div>
                  <div className="absolute top-[24px] left-[24px] flex items-center">
                    <h3 className="text-3xl text-white w-[285px]">Mainland China</h3>
                    <ArrowRight className="text-white w-[40px] h-[40px] ml-[12px] transition-transform duration-300 group-hover:translate-x-2" />
                  </div>
                </div>
              </Link>
            </div>

            {/* Product Grid for Mainland China */}
            <div className="grid grid-cols-2 flex-1 h-[400px]">
              {mainLandProducts.map((product, index) => (
                <div key={product.key} className={`flex justify-center items-center transition-colors group
                border-b border-[#747474] cursor-pointer text-[#cfcfcf] hover:text-[#fff] ${(index === 0 || index === 1) && 'border-t'}`}
                onClick={() => handleJump(product, index, '/mainland-china')}>
                  <h4 className="font-semibold text-[20px] text-left w-[220px] text-white">{ product.productName }</h4>
                  { product.productName && <ArrowRight className="w-[24px] h-[24px] transition-transform duration-300 group-hover:translate-x-2" /> }
                </div>
              ))}
            </div>
          </div>

          <div className="flex gap-[32px] mb-16">
            {/* Product Grid for Hong Kong */}
            <div className="grid grid-cols-2 flex-1 h-[400px]">
              {hongkongProducts.map((product, index) => (
                <div key={product.key} className={`flex justify-center items-center transition-colors group
                border-b border-[#747474] cursor-pointer text-[#cfcfcf] hover:text-[#fff] ${(index === 0 || index === 1) && 'border-t'}`}
                onClick={() => handleJump(product, index, '/hongkong-sar')}>
                  <h4 className="font-semibold text-[20px] text-left w-[220px] text-white">{ product.productName }</h4>
                   <ArrowRight className={`w-[24px] h-[24px] transition-transform duration-300 group-hover:translate-x-2 ${product.productName ? '' : 'invisible'}`} />
                </div>
              ))}
            </div>

            {/* HongKong SAR */}
            <div className="group">
              <Link to="/hongkong-sar" className="h-full">
                <div className="relative overflow-hidden mb-4 -">
                  <img
                    src={hongkongPng}
                    alt="HongKong-SAR"
                    className="w-[421px] h-[400px] object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 group-hover:bg-black/30 transition-colors duration-300"></div>
                  <div className="absolute top-[24px] left-[24px] flex items-center">
                    <h3 className="text-3xl text-white w-[285px]">HongKong-SAR</h3>
                    <ArrowRight className="text-white w-[40px] h-[40px] ml-[12px] transition-transform duration-300 group-hover:translate-x-2" />
                  </div>
                </div>
              </Link>
            </div>
          </div>

          <div className="flex gap-[32px] mb-16">
            {/* United States */}
            <div className="group">
              <Link to="/united-states" className="h-full">
                <div className="relative overflow-hidden mb-4 -">
                  <img
                    src={unitedPng}
                    alt="Mainland China"
                    className="w-[421px] h-[400px] object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                  <div className="absolute inset-0 group-hover:bg-black/30 transition-colors duration-300"></div>
                  <div className="absolute top-[24px] left-[24px] flex items-center">
                    <h3 className="text-3xl text-white w-[285px]">United States</h3>
                    <ArrowRight className="text-white w-[40px] h-[40px] ml-[12px] transition-transform duration-300 group-hover:translate-x-2" />
                  </div>
                </div>
              </Link>
            </div>

            {/* Product Grid for United States */}
            <div className="grid grid-cols-2 flex-1 h-[400px]">
              {unitedStatesProducts.map((product, index) => (
                <div key={product.key} className={`flex justify-center items-center transition-colors group
                border-b border-[#747474] cursor-pointer text-[#cfcfcf] hover:text-[#fff] ${(index === 0 || index === 1) && 'border-t'}`}
                onClick={() => handleJump(product, index, '/united-states')}>
                  <h4 className="font-semibold text-[20px] text-left w-[220px] text-white">{ product.productName }</h4>
                  <ArrowRight className={`w-[24px] h-[24px] transition-transform duration-300 group-hover:translate-x-2 ${product.productName ? '' : 'invisible'}`} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <TrialFormPage></TrialFormPage>
      <Footer />

      <TrialFormDialog open={ trialStatus } onOpenChange={ setTrialStatus }></TrialFormDialog>
    </div>
  )
}
